import React, { useEffect } from 'react'

import { FontWeight, Text } from '@gousto-internal/citrus-react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import { DeliveryCard } from 'routes/Checkout/Components/Delivery/DeliveryCard'

import css from './CustomersInAreaBanner.css'

export const CustomersInAreaBanner = ({
  amountOfCustomers,
  district,
  trackBannerAppearance,
  isWizardWithoutImagesEnabled,
}) => {
  useEffect(trackBannerAppearance, [trackBannerAppearance])

  return (
    <div
      className={classNames(css.customersInAreaContainer, {
        [css.wizardWithoutImagesContainer]: isWizardWithoutImagesEnabled,
      })}
    >
      <DeliveryCard
        iconName="icon-serving-size-blue"
        cardStyle="blue"
        customClass={css.socialPadding}
      >
        <Text size={1} fontWeight={FontWeight.SemiBold} className={css.districtText}>
          Join {amountOfCustomers.toLocaleString()} Gousto customers in {district}!
        </Text>
      </DeliveryCard>
    </div>
  )
}

CustomersInAreaBanner.propTypes = {
  amountOfCustomers: PropTypes.number.isRequired,
  district: PropTypes.string.isRequired,
  trackBannerAppearance: PropTypes.func.isRequired,
  isWizardWithoutImagesEnabled: PropTypes.bool,
}

CustomersInAreaBanner.defaultProps = {
  isWizardWithoutImagesEnabled: false,
}
